import { GuestSignUpForm, Modal, ModalContent } from '@toctoc/design-system';
import { FormProps, GuestSignUpModalProps } from './GuestSignUpModal.interface';
import { useEffect, useState } from 'react';
import { eOriginId, ePropertyCondition, STATUS } from '@/app/globalContext/globalContext.interfaces';
import { formatRut, rutValidator } from '@/utils/rutValidator';
import { emailValidator } from '@/utils/emailValidator';
import { formatTelefono, phoneValidator } from '@/utils/phoneValidator';

export const GuestSignUpModal = (props: GuestSignUpModalProps) => {
	const { isMobile, leadStatus, showModal, guestSignUpModalHandler, selectedPropertyData, generateLead, saveTempLogInData, listaSeoUrl } = props ?? {};
	const {
		comuna,
		tipoPropiedad,
		tipoOperacion,
		titulo,
		precios,
		imagenPrincipal,
		urlFicha,
		idEstadoPropiedad,
		idProperty
	} = selectedPropertyData ?? {};

	const { src } = imagenPrincipal ?? {};

	const isLoading = leadStatus === STATUS.pending;
	const loadingText = isLoading ? `Generando ${idEstadoPropiedad === ePropertyCondition.new ? 'cotización' : 'contacto'}` : '';

	const [form, setForm] = useState<FormProps>({
		rut: {
			'value': '',
			'error': ''
		},
		fullName: {
			'value': '',
			'error': ''
		},
		email: {
			'value': '',
			'error': ''
		},
		phone: {
			'value': '',
			'error': ''
		}
	});
	const [validForm, setValidForm] = useState<boolean>(false);

	const formHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target ?? {};
		let formattedValue = value;
		if (name === 'rut') {
			formattedValue = formatRut(value)
		}
		setForm(formData => ({ ...formData, [name]: { value: formattedValue, error: validators[name as keyof FormProps]?.(value) ?? '' } }));
	};

	useEffect(() => {
		if (form) {
			const hasErrors = Object.values(form).every(field => field.value !== '' && field.error === '');
			setValidForm(hasErrors);
		}
	}, [form]);

		type ValidatorFn = (value: string) => string | null;
		type Validators = Record<keyof FormProps, ValidatorFn>;

		const validators: Validators = {
			fullName: (value) => {
				if (!value) return 'Debes ingresar tu nombre';
				const nameRegex = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]+ [A-Za-zÁÉÍÓÚÜÑáéíóúüñ]+$/;
				const validData = nameRegex.test(value);
				if (!validData) return 'Nombre inválido';
				return '';
			},
			email: (value) => {
				if (!value) return 'Debes ingresar tu email';
				const validEmail = emailValidator(value);
				if (!validEmail) return 'Email inválido';
				return '';
			},
			rut: (value) => {
				if (!value) return 'Debes ingresar tu rut';
				const formattedRut = formatRut(value);
				const isValid = rutValidator(formattedRut)
				if (!isValid) return 'Rut inválido';
				return '';
			},
			phone: (value) => {
				if (!value) return 'Debes ingresar un teléfono';
				const formattedPhone = formatTelefono(value);
				const isValid = phoneValidator(formattedPhone);
				if (!isValid) return 'Teléfono inválido';
				return '';
			}
		};

		const closeHandler = () => {
			guestSignUpModalHandler(false)
		}
	
		const submitHandler = () => {
			const [name, lastname] = form?.fullName?.value?.split(' ') ?? [];
			saveTempLogInData({ name: form?.fullName?.value, email: form?.email?.value })
			generateLead({
				propertyId: idProperty,
				originId: idEstadoPropiedad === ePropertyCondition.new ? eOriginId.listaSeoQuote : eOriginId.listaSeoContact,
				utmSource: listaSeoUrl,
				formGuest: {
					name: name,
					lastname: lastname,
					rut: form?.rut?.value,
					phone: form?.phone?.value,
					email: form?.email?.value
				}
			});
		}

		return (
			<Modal open={showModal} claseAux='guest-sign-up-modal' handleClose={closeHandler} maxWidth='xl'>
				<ModalContent>
					<GuestSignUpForm
						isMobile={isMobile}
						commune={comuna}
						propertyType={tipoPropiedad}
						operationType={tipoOperacion}
						title={titulo}
						mainPrice={precios[0]?.value}
						altPrice={precios[1]?.value}
						imgUrl={src}
						projectUrl={urlFicha}
						tacUrl={'#'}
						form={form}
						formHandler={(e: React.ChangeEvent<HTMLInputElement>) => formHandler(e)}
						closeHandler={closeHandler}
						submitHandler={submitHandler}
						validForm={validForm}
						loading={isLoading}
						loadingText={loadingText}
					/>
				</ModalContent>
			</Modal>
		)
}